import React from "react";

const FileItem = (props) => {
    const { file, onRemoveFile, withoutRemove, withoutDownload } = props;
    const { id, accessUrlLink, originalFileName } = file;

    return (
        <div className="news-file">
            <div className="news-file__name">{originalFileName}</div>
            <div className="news-file__actions">
                {!withoutRemove && (
                    <div
                        className="news-file__action news-file__action--remove"
                        onClick={onRemoveFile.bind(this, id)}
                    />
                )}
                {!withoutDownload && (
                    <a
                        href={accessUrlLink}
                        download={originalFileName}
                        className="news-file__action news-file__action--download"
                        target="_blank"
                        rel="noopener noreferrer"
                    />
                )}
            </div>
        </div>
    );
};

export default FileItem;
